import React from 'react';
import { Navigate } from 'react-router-dom';
import { Container, Alert, Box } from '@mui/material';
import authService from '../services/authService';

const RoleProtectedRoute = ({ children, allowedRoles = [], deniedRoles = [], redirectTo = '/' }) => {
  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = authService.getCurrentUser();
  
  // If no user data, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userRole = user.role || user.user_role || '';

  // Check if user role is explicitly denied
  if (deniedRoles.length > 0 && deniedRoles.includes(userRole)) {
    return (
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            عذراً، هذه الصفحة غير متاحة لنوع حسابك
          </Alert>
          <Alert severity="info">
            {userRole === 'whole' ? 
              'هذه الخدمة متاحة فقط للعملاء العاديين. كعميل جملة، يمكنك الوصول إلى متجر الجملة من القائمة الرئيسية.' :
              'ليس لديك الصلاحية للوصول إلى هذه الصفحة.'
            }
          </Alert>
        </Box>
      </Container>
    );
  }

  // Check if user role is in allowed roles (if specified)
  if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  // User has the correct role, render the protected component
  return children;
};

export default RoleProtectedRoute;
